import Connection from "../core/ApiConnection";

export class SocialService {

    async getList() {
        return await Connection.get('/social').then(res => res.data.items);
    }

    async saveData(data) {
        return await Connection.post('/social', data).then( res => res.data );
    }

    async updateData(data) {
        return await Connection.put('/social/' + data._ID, data).then( res => res.data );
    }

    async deleteData(data) {
        return await Connection.delete('/social/' + data).then( res => res.data );
    }

}
